import React, { useEffect, useRef, useState } from 'react';
import styles from './Footer.module.css';
const imagen2 = "https://ik.imagekit.io/b4rykldk3/healthy_bite_qr.webp?updatedAt=1777044887043";
import { Facebook, Instagram, Music, Plus, Share2 } from 'lucide-react';
import { FaTiktok } from 'react-icons/fa';

const Footer = () => {
  const sectionRef = useRef(null);
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIsVisible(true);
          observer.unobserve(entry.target);
        }
      },
      {
        root: null,
        rootMargin: '0px',
        threshold: 0.2,
      }
    );

    if (sectionRef.current) {
      observer.observe(sectionRef.current);
    }

    return () => {
      if (sectionRef.current) {
        observer.unobserve(sectionRef.current);
      }
    };
  }, []);

  const containerClassName = `${styles.container} ${isVisible ? styles.animate : ''}`;

  return (
    <footer className={containerClassName} ref={sectionRef}>
      {/* Columna Verde - Izquierda */}
      <div className={`${styles.sectionContainer} ${styles.greenContainer}`}>
        <div className={styles.backgroundLoader}></div>
        
        <div className={styles.content}>
          <h2 className={styles.title}>ÚNETE A LA REVOLUCIÓN</h2>
          
          <div className={styles.twoColumns}>
            {/* Subcolumna izquierda - Redes Sociales */}
            <div className={styles.leftSubColumn}>
              <h3 className={styles.subTitle}>SÍGUENOS</h3>
              <div className={styles.socialIconsContainer}>
                <a 
                  href="https://www.facebook.com/healthybite" 
                  target="_blank" 
                  rel="noopener noreferrer" 
                  className={styles.socialLink}
                >
                  <Facebook size={24} />
                  <span>Facebook</span>
                </a>
                <a 
                  href="https://www.instagram.com/healthybite.mzl" 
                  target="_blank" 
                  rel="noopener noreferrer" 
                  className={styles.socialLink}
                >
                  <Instagram size={24} />
                  <span>Instagram</span>
                </a>
                <a 
                  href="https://www.tiktok.com/@healthy.bitemzl" 
                  target="_blank" 
                  rel="noopener noreferrer" 
                  className={styles.socialLink}
                >
                  <FaTiktok size={24} />
                  <span>Tiktok</span>
                </a>
              </div>
              <p className={styles.smallText}>
                Síguenos en redes sociales para estar al día de todas nuestras novedades.
              </p>
            </div>
            
            {/* Subcolumna derecha - Información */}
            <div className={styles.rightSubColumn}>
              <h3 className={styles.subTitle}>INFORMACIÓN</h3>
              <div className={styles.infoLinksContainer}>
                <a href="#" className={styles.infoLink}>Localización de la Tienda</a>

               <div className={styles.mapContainer}>
  <a
    href="https://www.google.com/maps?q=5.051363109845237,-75.48784499910894"
    target="_blank"
    rel="noopener noreferrer"
  >
    <iframe
      src="https://www.google.com/maps/embed?pb=!3m2!1ses-419!2sco!4v1773709497870!5m2!1ses-419!2sco!6m8!1m7!1seuwIsug24Ihv1y9Ifj61ow!2m2!1d5.051363109845237!2d-75.48784499910894!3f240.01503!4f0!5f0.7820865974627469"
      width="100%"
      height="200"
      style={{ border: 0, borderRadius: '8px', marginTop: '12px', pointerEvents: 'none' }}
      loading="lazy"
      referrerPolicy="no-referrer-when-downgrade"
      title="Ubicación de la tienda"
    />
  </a>
</div>
               <a 
  href="https://docs.google.com/forms/d/e/1FAIpQLSf4fUhUnZ8Uc5BGcHPV7XBK_23CUm2yhW_186of_LxMq4g91w/viewform" 
  target="_blank" 
  rel="noopener noreferrer" 
  className={styles.infoLink}
>
  Trabaja con Nosotros
</a>
                <a  href="https://wa.me/573147139843?text=Hola%2C%20quiero%20obtener%20m%C3%A1s%20informaci%C3%B3n"
  target="_blank"
  rel="noopener noreferrer"
  className={styles.infoLink}
>
  Contacto
</a>
              </div>

              {/* Mapa de la tienda */}
              
            </div>
          </div>
          
          <p className={styles.description}>
            ©2025 Oscar orozco ®
          </p>
        </div>
      </div>
      
      {/* Columna Gris - Derecha */}
      <div className={`${styles.sectionContainer} ${styles.grayContainer}`}>
        <div className={styles.backgroundLoader}></div>
                  
        <div className={styles.content}>
          <h2 className={styles.title}>NUESTRA LISTA DE SPOTIFY</h2>
          <p className={styles.description}>
            Escanea el QR para disfrutar de nuestra lista de reproducción mientras disfrutas de la mejor comida.
          </p>
          
          <div className={styles.spotifyContainer}>
            <div className={styles.qrCodeSection}>
              <img src={imagen2} className={styles.qrIcon} />
              <p className={styles.qrText}>Escanea este código</p>
            </div>
            
            <div className={styles.spotifyInstructions}>
              <h3 className={styles.instructionTitle}>¿Cómo añadir tus canciones?</h3>
              
              <div className={styles.instructionStep}>
                <div className={styles.stepNumber}>1</div>
                <div className={styles.stepContent}>
                  <strong>Abre Spotify</strong> tras escanear el QR
                </div>
              </div>
              
              <div className={styles.instructionStep}>
                <div className={styles.stepNumber}>2</div>
                <div className={styles.stepContent}>
                  <strong>Busca tu canción favorita</strong> usando la lupa
                  <Music size={16} className={styles.stepIcon} />
                </div>
              </div>
              
              <div className={styles.instructionStep}>
                <div className={styles.stepNumber}>3</div>
                <div className={styles.stepContent}>
                  <strong>Mantén presionada la canción</strong> y selecciona "Añadir a lista"
                  <Plus size={16} className={styles.stepIcon} />
                </div>
              </div>
              
              <div className={styles.instructionStep}>
                <div className={styles.stepNumber}>4</div>
                <div className={styles.stepContent}>
                  <strong>Elige nuestra lista</strong> y compártela con tus amigos
                  <Share2 size={16} className={styles.stepIcon} />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;